import useAttrs from 'dcode/uses/useAttrs'
import { props as main } from '@/components/CItem/props'

export default function attrItem ({
  props,
  pointer = [
    'underline',
    'color',
    'tag',
    'size',
    'border'
  ],
  items = {},
  attrs = {}
}) {
  return useAttrs({
    code: 'item',
    props: main,
    pointer,
    original: props,
    items,
    attrs
  })
}
